var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevronForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8839 10.8839C19.372 10.3957 19.372 9.60427 18.8839 9.11612L10.9289 1.16117C10.4408 0.67301 9.64932 0.67301 9.16117 1.16117C8.67301 1.64932 8.67301 2.44078 9.16117 2.92893L16.2322 10L9.16117 17.0711C8.67301 17.5592 8.67301 18.3507 9.16117 18.8388C9.64932 19.327 10.4408 19.327 10.9289 18.8388L18.8839 10.8839ZM17 11.25H18V8.75H17V11.25Z",
    fill: "#40D9B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8839 10.8839C11.372 10.3957 11.372 9.60427 10.8839 9.11612L2.92893 1.16117C2.44078 0.67301 1.64932 0.67301 1.16117 1.16117C0.67301 1.64932 0.67301 2.44078 1.16117 2.92893L8.23223 10L1.16117 17.0711C0.67301 17.5592 0.67301 18.3507 1.16117 18.8388C1.64932 19.327 2.44078 19.327 2.92893 18.8388L10.8839 10.8839ZM9 11.25H10V8.75H9V11.25Z",
    fill: "#40D9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronForward);
export default __webpack_public_path__ + "static/media/double-chevron-forward.5b5e3d7bc8dc16717d9eff8103d15092.svg";
export { ForwardRef as ReactComponent };